document.addEventListener('DOMContentLoaded', function () {
  const colorFilter = document.getElementById('colorFilter');
  const patternFilter = document.getElementById('patternFilter');

  function filterImages() {
    const color = colorFilter.value;
    const pattern = patternFilter.value;

    document.querySelectorAll('.gallery-image').forEach(image => {
      const imgColor = image.dataset.color;
      const imgPattern = image.dataset.pattern;

      const matchesColor = color === 'all' || imgColor === color;
      const matchesPattern = pattern === 'all' || imgPattern === pattern;

      image.style.display = (matchesColor && matchesPattern) ? 'block' : 'none';
    });
  }

  colorFilter.addEventListener('change', filterImages);
  patternFilter.addEventListener('change', filterImages);

  filterImages(); // initialize
});
